import * as types from '../mutation-types';
import activity from '../../api/activity';
import _ from 'lodash';

const state = {
  activity: [],
  comments: [],
  emails: [],
  loading: {
    activity: false,
    comments: false,
    emails: false
  }
};

const getters = {
  Activity: state => state.activity,
  Comments: state => state.comments,
  EmailLog: state => state.emails,
  LoadingComments: state => state.loading.comments
};

const actions = {
  getComments({ commit }, id) {
    commit(types.LOAD_ACTIVITY_COMMENTS, true);
    activity
      .getComments(id)
      .then(response => {
        commit(types.SET_ACTIVITY_COMMENTS, response.hits);
      })
      .catch(error => console.log(error));
  },
  clearComments({ commit }) {
    commit(types.CLEAR_ACTIVITY_COMMENTS);
  },
  insertComment({ commit }, comment) {
    commit(types.INSERT_ACTIVITY_COMMENT, comment);
  }
};

const mutations = {
  [types.SET_ACTIVITY_COMMENTS](state, comments) {
    state.comments = _.map(comments, '_source');
    state.loading.comments = false;
  },
  [types.CLEAR_ACTIVITY_COMMENTS](state) {
    state.comments = [];
  },
  [types.LOAD_ACTIVITY_COMMENTS](state, isLoading) {
    state.loading.comments = isLoading;
  },
  [types.INSERT_ACTIVITY_COMMENT](state, comment) {
    state.comments.push(comment);
    state.comments = _.orderBy(state.comments, ['created_at'], ['desc']);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
